// extracted by mini-css-extract-plugin
export default {"fixWidth":"Forecast_fixWidth__UaSl3","gridTitle":"Forecast_gridTitle__35Vgv"};